export default "__VITE_ASSET__CrPKxePC__"